import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useLocalState } from '../../util/useLocalStorage';

const PrivateRoute = ({ children }) => {
    const [jwt, setJwt] = useLocalState("", "jwt");
    const location = useLocation();
    if (!jwt) {
        // enlace de un correo sin sesion: despues del login se vuelve a esa pantalla (ADR-002 S9)
        try { sessionStorage.setItem('opem.destino', location.pathname + location.search); } catch (e) { /* noop */ }
        return <Navigate to="/login" />;
    }
    return children;

};

export default PrivateRoute;